import { updateEndMeeting, searchDictionaryInfo, getVirtualParticipants} from "@/api/meeting";
import { setStore, getStore, removeStore } from '@/utils/utils.js'
import _ from 'lodash'
import config from '@/config/config.js'
export default {
    data() {
        return {
            config: config,
            socketStatus: false,
            mytime: '',
            ptivateMytime: '',
            userToken: '',
            selfName: null,
            selfRole: '',
            mediatorName: '',
            ws: '',
            heartbeatFun: '',
            wsclosed: true,
            userID: null, //用户id
            workbenchstatus: false,
            currentPlayerMedia: true, // 当事人再次进入视频 是否是被调解员禁用状态 true为可以推流
            updatestatus: true, // 是否已经更新视频时间 true为没有更新
            viewrecord: false, // 用户显示调解笔录
            tagsrecord: false, // 用户未签名调解笔录显示红点
            voiceSwitchStatus: false, // 语音识别开关初始
            ownvideoopen: true,
            // ownaudioopen: true,
            isvideoopen: true,
            isaudioopen: true, //当前语音是否开启
            isaudioopenIFly: false,
            memberStatus: true, // 是否录制视频
            members: [],
            member_list: [],
            mainView: {
                id: '',
                name: '',
                stream: '',
                role: '',
                rolename: '',
                ts: '',
                openId: '',
                request: ''
            },
            requestingPushers: {},
            pusherVideosDisplay: {},
            onlineStatus: {},
            messageActive: {},
            isMediatorMessage: false, // 当事人是否有收到调解员新的消息提示
            isMediatorMessageRead: false, // 当事人是否已经阅读了调解员的消息
            recentMembers: [],
            mode: "camera",
            mediatorInfo: {}, //调解员信息
            ismediator: false,
            canDraw: false,
            userDocumentType: {
                "MEDIATION_BOOK": '调解协议',
                "NO_DISSENT_MEDIATION_SCHEME": '无异议调解方案',
                "UNDISPUTED_FACT": '无争议事实确认'
            }, // 用户协议书
            userDocumentStatus: {},
            curCaseDetail: {}, //  案件详情
            comdata: {},
            allmembertype: {
                "LITIGANT_WITNESS": "证人",
                "LITIGANT_THIRD": "第三人",
                'APPLICANT': '申请人',
                'APPLICANT_AGENT': '申请人代理人',
                'LITIGANT': '参会人',
                'RESPONDENT': '被申请人',
                'RESPONDENT_AGENT': '被申请人代理人',
                'MEDIATOR': '仲裁员',
                'OTHER': '其他人',
                'PETITION_AGENT': '信访代理人',
                'MEDIATOR_HELP_TEMPORARY': '协助调解员',
                'MEDIATOR_HELP': '协助调解员',
                'INVITATION_WATCHER': '观摩人',
                'INVITATION_WATCHER2': '仲裁员'
            },
            scrollLength: 0,
            videotape: false,
            mic_pressed: false,
            ismember: true,
            iswatcher: true,
            istemporary: false,
            invite: 0, // 是否是通过邀请进入视频的
            caseStatus: '',
            insideshow: false,
            onceadd: true,
            imgcode: '',
            currentMessageType: '', // 当前获取的是公频记录还是私聊记录
            audioStatus: true, // 当事人的音频是否可以自己控制（未被调解员关闭）
            videoStatus: true, // 当事人的视频是否可以自己控制（未被调解员关闭）
            faceInit: true,
            selectedMainViewId: null, //被设置为主视频人员的id
            speechMode: null, //当前是哪种发言模式（ FREE 自由发言   SPECIFY 指定发言）
            handMap: {}, //举手人员的列表
            isRaiseHand: false, // 当前用户--当事人是否举手（这个状态对当前用户是调解员没用）
            firstHand: {},
            isface: false,
            lastLoginInfo: {
                lastLoginMember: '',
                intoRoomTime: '',
                outRoomTime: '',
            },
            isOnPriva: false,
            isPrivateRoom: false,
            privateUserId: '',
            checked: false,
            ScreenId: '',
            ScreenName: '',
            isFirstEnter: true, //是否是第一次进入，第一次进入不提示xxx进入视频，后续的提示
            currentSpeechUserId: null, // 指定模式下，当前发言的人的id
            isOutPrivate: false,
            streamId: '',
            currentLoginId: '',
            hasNoPersonq: 0,
            onRemoteStreamUpdateInfo: '', //拉取视频流返回信息
            hiddenScreenData: '',    //屏蔽视频保存当前人ROOM_INFO信息
            recordOnce: 0,      //全员在线提示录制视频弹窗只弹一次
            onlinePerson: 0,
            ROOMData: '',   //保存room事件对象
            Bobaovideo1: '',
            Bobaovideo2: '',
            virtualParticipants: []
        };
    },
    create() {
        // this.time_fun(true);
    },
    mounted() {
        this.handleBobao()
    },
    watch: {
        members: { // 监听成员变化
            handler: function(newData, oldData) {
                let self = this;
                
                self.$nextTick(function() {
                    for (var index in newData) {
                        let videoElement = document.getElementById("v_" + newData[index].id);
                        if (videoElement) {
                            if(newData[index].stream) {
                                videoElement.srcObject = newData[index].stream;
                                
                                if (newData[index].id == this.userID) {
                                    videoElement.muted = true;
                                } else {
                                    videoElement.muted = false;
                                }
                            }
                        }
                    }
                });
            },
            deep: true
        },
        mainView: {
            handler: function(newData, oldData) {
                let self = this;
                
                self.$nextTick(function() {
                    let videoElement = document.getElementById("localVideo");
                    if (videoElement) {
                        if(newData.stream) {
                            videoElement.srcObject = newData.stream;
                            if (newData.id == self.userID) {
                                videoElement.muted = true;
                            } else {
                                videoElement.muted = false;
                            }
                        }
                    }
                });
            },
            deep: true
        },
        member_list: {
            handler: function(newData, oldData) {
                let self = this;
                
                self.$nextTick(function() {
                    for (var index in newData) {
                        self.$set(self.onlineStatus, newData[index].memberId, newData[index].memberStatus)
                    }
                })
                self.memberVudeoType(this.onRemoteStreamUpdateInfo, false)
            }
        },
    },
    methods: {
        closeInstantChat() {
            this.ws.send(JSON.stringify({event:'OTHER', data: {event:'leaveroom',roomId: this.roomID, leaveMemberId:this.userID}}))
            this.RTC && this.RTC.quit();
            this.ws.close();
            clearInterval(this.heartbeatFun)
        },
        webRtcInit() {
            let self = this
            //获取虚拟用户的参会信息
            getVirtualParticipants({
                mediationRoomId: this.roomID
            }).then((res)=>{
                if(res.data.code === 1000 && res.data.data) {
                    self.virtualParticipants = res.data.data                        
                    self.showPrivateChat = !self.virtualParticipants.length
                    WebRTCAPI.fn.detectRTC(function(info) {
                        if (!info.support) {
                            self.$alert('<h4 class="title_normal">温馨提示</h4><p>当前浏览器不支持视频会议，请使用Chrome(版本要求高于52)或者QQ浏览器(10.2)</p>', '温馨提示', {
                                dangerouslyUseHTMLString: true,
                                confirmButtonText: '确定',
                                confirmButtonClass: 'meeting_button_primary_small',
                                customClass: 'alert_quit'
                            }).then(() => {
                                history.back()
                            })
                        } else {
                            self.enterRoom(self.selfRole)
                        }
                    });
                }
            })
            
        },
        enterRoom(member) { // websocket链接
            let self = this,
                hostName = config.hostName
            let ws
            if(getStore('appName')) {
                ws = this.ws = new WebSocket('wss://' + hostName + '/scavengerIm/joinRoom/' + this.roomID + '?JWTToken=' + this.userToken + '&appName=' + getStore('appName') + '&watcher=' + self.ispusher)
            } else {
                ws = this.ws = new WebSocket('wss://' + hostName + '/scavengerIm/joinRoom/' + this.roomID + '?JWTToken=' + this.userToken + '&appName=' + 'gzzc' + '&watcher=' + self.ispusher)
            }
                // this.$set(this.comdata, 'wselement', ws)
            ws.onopen = function(evt) {
                
                self.socketStatus = true
                self.time_fun(true);
                self.heartbeatFun = setInterval(self.heartbeat, 30000);
            };
            ws.onmessage = function(evt) {
                // ws.close();
                let res = JSON.parse(evt.data)
                if (res.event == "ROOM") {
                    console.log(res.data)
                    let originalData = res.data
                    let members = originalData.members
                    // 对原始数据补充
                    console.log(self.virtualParticipants)
                    self.virtualParticipants.map(item => {
                        if (item.userName !== 'DISPLAY_SCREEN') {
                            item.master = false
                            item.memberId = item.userId
                            item.memberName = item.roleName
                            item.memberStatus = "INIT"
                            if (item.userName === 'ARBITRATOR') {
                                item.memberType = 'MEDIATOR'
                            } else {
                                item.memberType = 'APPLICANT'
                            }
                            item.memberVideoStatus = true
                            item.memberVoiceStatus = true
                            item.shield = false
                            item.videoOperator = "OWNER"
                            item.voiceOperator = "OWNER"
                            members.push(item)
                        }
                    })
                    originalData.members = members
                    
                    self.ROOMData = originalData;
                    self.initRoomInfo(originalData)
                }
                if (res.event == "RTC_ROOM_INFO") {
                    self.hiddenScreenData = res.data;
                    //防止被屏蔽用户刷新（进入后还是屏蔽状态）
                    let itemshield = self.member_list.filter(item => item.memberId == self.userID);
                    if(itemshield[0] && !itemshield[0].shield) {
                        self.initRTC(res.data)
                    }
                }
                if (res.event == "LIST_NEWEST_EMOTIONAL") {
                    self.emotionalFun(res.data.list)
                }
                if (res.event == "LIST_MESSAGE") {
                    if (self.currentMessageType == 'public') {
                        self.$refs.inside.loadMsgList(res.data)
                    } else if (self.currentMessageType == 'private') {
                        self.$refs.privatechat.loadMsgList(res.data)
                    }
                }
                if (res.event == "START_RECORD") {
                    if (self.ismediator) { self.recordResponse(res.data) }
                }
                if (res.event == "FORCE_VIDEO") {
                    if (!self.ismediator) {
                        self.privateUserId = res.data.receiverId;
                        // clearInterval(self.interval);
                        self.time_fun(false);
                        self.time_funs(false);
                        self.ptivateMytime = '00:00:00';
                        if (res.data.receiverId == self.userID) {
                            self.isOnPriva = true;
                            
                            self.closeInstantChat();
                            self.$router.push({
                                path: '/meetingChat',
                                query: {
                                    roomId: res.data.roomId,
                                    meetingid: res.data.meetingId,
                                    caseid: res.data.caseId
                                }
                            })

                        } else {
                            self.time_funs(true);
                            // self.isOnPriva = false
                            self.sendRoom()

                        }
                    }
                }
                if (res.event == "GET_TEMP_MEMBER") {
                    let opts = JSON.stringify(res.data)
                    let id = self.ScreenId;
                    let name = self.ScreenName;
                    setStore('checked', self.checked);
                    self.DialogVisible = false;
                    
                    const { href } = self.$router.resolve({
                        path: "/throwingScreen",
                        query: {
                            userId: id,
                            userName: name,
                            caseId: self.$route.query.caseid,
                            roomId: self.$route.query.roomId,
                            meetingId: self.$route.query.meetingId,
                            opts: opts,
                            streamId: self.streamId
                        }
                    });
                    window.open(href, '_blank');
                    // }
                }

                if (res.event == "FORCE_QUIT_PRIVATE_VIDEO") {
                    
                    self.isOutPrivate = true;
                    self.isOnPriva = false;
                    if (self.isOutPrivate) {
                        history.back()
                    }
                }
                if (res.event == 'QUIT_PRIVATE_VIDEO') {
                    self.isOnPriva = false;
                    self.isOutPrivate = true;
                }
                if (res.event == "BROADCAST_MESSAGE") {
                    
                    if (Boolean(res.data.receiver)) {
                        self.$refs.privatechat.uploadMsgList(res.data);
                        if (res.data.sender.memberId != self.userID) {
                            if (!Boolean(self.messageActive[res.data.sender.memberId].isread)) {
                                self.$set(self.messageActive[res.data.sender.memberId], 'isnew', true)
                            }
                            
                            
                            if (!self.ismediator && !self.isMediatorMessageRead) {
                                self.isMediatorMessage = true
                            }
                            
                        }
                    } else {
                        self.$refs.inside.uploadMsgList(res.data)
                    }
                }
                if (res.event == "SEND_BOOK") {
                    if (!self.iswatcher && !self.istemporary) { self.$refs.inside.broadcastReceive(res.data) }
                }
                if (res.event == "OTHER") {
                    // self.$refs.inside.broadcastReceive(res.data)
                    let typeEvent = JSON.parse(res.data).event
                    if(typeEvent === 'SEND_MATERIAL') {
                        //发送材料自动刷新上传事件
                        self.$refs.inside.$refs.comCaseinfo.getMeetingDetail(self.caseID, self.meetingID)
                    }
                    if(typeEvent === 'SEND_BOBAO_DIALOG') {
                        //播报调解关闭用户端弹窗接收事件
                        self.$refs.Dialogbobao.DialogbobaoVisible = JSON.parse(res.data).dialog                   
                    }
                }
                if (res.event == "SHIELD_MEMBER") {  //屏蔽视频退出当事人腾讯视频流事件
                    if(self.selfRole !== 'MEDIATOR') {
                        let loginInfo = JSON.parse(getStore("loginInfo"))
                        if (res.data.memberId === loginInfo.memberId) {
                            if (res.data.shield) {
                                self.RTC && self.RTC.quit();
                                self.$message({ message: '仲裁员请您暂时回避庭审 稍后恢复 感谢配合', type: 'warning', customClass: 'pop-message', duration: 0});
                            } else {
                                self.$message.closeAll()
                                self.initRTC(self.hiddenScreenData);
                                self.$set(self.pusherVideosDisplay, res.data.memberId, false)
                            }
                        } 
                    }
                    self.sendRoom();
                }
                if (res.event == "SWITCH_MEDIA") { // 监听调解员的开关音视频
                    // 当事人页面被动做出响应
                    if (!self.iswatcher) {
                        // 调解员发起语音识别控制
                        if (res.data.mediaType == 'VOICE_DISCERN') {
                            // 将当前的麦克风状态 带入
                            self.$refs.inside.speechDiscernControl(res.data,self.isaudioopen)
                        } else {
                            self.partyReceiveMedia(res.data)
                        }
                    }
                }
                if (res.event == "HAND") {
                    self.receiveHand(res.data)
                }
                if (res.event == "CLOSE_ROOM") {
                    self.closeRoomVideo(res.data)
                }
                if (res.event == "RECESS_COURT") {
                    self.pauseRoomVideo()
                    console.log("休庭")
                }
                if (res.event == "ERROR") {
                    if (res.data['code'] == 1003) {
                        self.$alert(res.data['message'], '温馨提示', {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'meeting_button_primary_small',
                            showClose: false,
                            customClass: 'meetbox',
                            callback: action => {
                                // history.back()
                            }
                        })
                    }
                    if (res.data['code'] == 9999) {
                        self.$alert(res.data['message'], '温馨提示', {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'meeting_button_primary_small',
                            showClose: false,
                            customClass: 'meetbox',
                            callback: action => {
                                // history.back()
                            }
                        })
                    } else if (res.data['code'] == 1002) {
                        self.$alert('请重新登录', '温馨提示', {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'meeting_button_primary_small',
                            showClose: false,
                            customClass: 'meetbox',
                            callback: action => {
                                self.$router.push({
                                    path: '/login',
                                })
                            }
                        })
                    } else {
                        self.$alert(res.data['message'], '温馨提示', {
                            confirmButtonText: '确定',
                            confirmButtonClass: 'meeting_button_primary_small',
                            showClose: false,
                            customClass: 'meetbox',
                            callback: action => {}
                        })
                    }
                }
                if (res.event == "SPEECH_MODE_CHANGE") { // 监听调解员修改发言模式（指定发言、只有发言）
                    // 当事人页面被动做出响应
                    self.onSpeechModeChange(res.data)
                }
                if (res.event == "DISCIPLINE_PLAY") { // 监听调解员
                    // 当事人页面被动做出响应
                    if(self.comdata.roleType !== 'MEDIATOR') {
                        if(res.data.playStatus !== 'END') {
                            if(JSON.parse(res.data.type).audiotype === 'bobao1') {
                                self.$refs.Dialogbobao.handlePlay1(res.data.type)
                            } else {
                                self.$refs.Dialogbobao.handlePlay2(res.data.type)
                            }
                        }
                    }
                    // if(res.data.playStatus === 'END' && self.comdata.roleType === 'MEDIATOR') {
                    //     if(res.data.type === 'bobao1') {
                    //         self.$message({
                    //             message: '用户端的当事人的权利与义务播报完成',
                    //             type: 'success'
                    //         });
                    //     } else {
                    //         self.$message({
                    //             message: '用户端的仲裁庭纪律播报完成',
                    //             type: 'success'
                    //         });
                    //     }
                    // }
                }
            };
            ws.onclose = function(evt) {
                
                self.socketStatus = false
                self.time_fun(false)
                self.time_funs(false)
                    // if (self.wsclosed) self.$message({ message: '会议连接中断', type: 'warning' })
            }
        },
        initRTC(opts) { // 初始化webRTC
            var self = this;
            
            self.goOutRoomInfo = [];
            var RTC = this.RTC = new WebRTCAPI({
                sdkAppId: opts.sdkAppId,
                openid: opts.userId,
                userSig: opts.userSig,
                accountType: opts.accountType,
                closeLocalMedia: self.ispusher,
                useCloud: 1
            }, function() {
                if (opts.joinType == 'MEMBER') {
                    self.ismember = false
                }
                RTC.enterRoom({
                    roomid: opts.roomId * 1,
                    privateMapKey: opts.privateMapKey,
                    role: "user"
                })
                
            }, function(error) {
                self.$alert('视频连接失败，请重试', '温馨提示', {
                    confirmButtonText: '重试',
                    confirmButtonClass: 'meeting_button_primary_small',
                    showClose: false,
                    customClass: 'meetbox',
                    callback: action => {
                        self.enterRoom(self.selfRole)
                    }
                })
                
            });
            // if(self.currentPlayerMedia){
            RTC.on("onLocalStreamAdd", function(info) {

                if(!self.isvideoopen){
                    self.RTC.closeVideo()
                }
                if(!self.isaudioopen){
                    self.RTC.closeAudio()
                }
                    let thename, themembertype, streamId;
                    for (let j = 0; j < self.member_list.length; j++) {
                        if (self.member_list[j].memberId == self.userID) {
                            thename = self.member_list[j].memberName
                            themembertype = self.member_list[j].memberType
                            streamId = self.member_list[j].streamId
                        }
                    }
                    if (self.selfRole == "APPLICANT" || self.selfRole == "LITIGANT_WITNESS" ||self.selfRole == "LITIGANT_THIRD" ||self.selfRole == "APPLICANT_AGENT" || self.selfRole == "RESPONDENT" || self.selfRole == "RESPONDENT_AGENT" || self.selfRole == "PETITION_AGENT" || self.selfRole == "MEDIATOR_HELP_TEMPORARY" || self.selfRole == "MEDIATOR_HELP" || self.selfRole == 'LITIGANT' || self.selfRole == 'INVITATION_WATCHER' || self.selfRole == 'INVITATION_WATCHER2') {
                        let videoElement = document.getElementById("v_" + self.userID);
                        if (videoElement) {
                            videoElement.srcObject = null;
                        }
                        if (info.stream) {
                            let temp = [],
                                dtemp = [];
                            for (let i = 0; i < self.members.length; i++) {
                                if (self.members[i].openId != self.userID) {
                                    temp.push(self.members[i])
                                }
                            }
                            let member = {
                                id: self.userID,
                                name: thename,
                                request: false,
                                role: themembertype,
                                rolename: self.allmembertype[themembertype],
                                ts: Date.now(),
                                stream: info.stream,
                                openId: self.userID,
                                streamId: streamId
                            };
                            temp.unshift(member);
                            self.members = temp;
                            console.log(self.members)
                        } else {
                            
                        }
                    }
                    if (self.selfRole == "MEDIATOR") {
                        let videoElement = document.getElementById("localVideo");
                        videoElement.srcObject = info.stream;
                        videoElement.muted = true;
                        // 
                        for (let j = 0; j < self.member_list.length; j++) {
                            if (self.member_list[j].memberId == self.userID) {
                                streamId = self.member_list[j].streamId
                            }
                        }
                        self.$set(self.mainView, 'id', self.userID)
                        self.$set(self.mainView, 'name', self.selfName)
                        self.$set(self.mainView, 'stream', info.stream)
                        self.$set(self.mainView, 'role', 'MEDIATOR')
                        self.$set(self.mainView, 'rolename', '仲裁员')
                        self.$set(self.mainView, 'request', false)
                        self.$set(self.mainView, 'ts', Date.now())
                        self.$set(self.mainView, 'openId', self.userID)
                        self.$set(self.mainView, 'streamId', streamId)
                    }
                    
                    if (!self.isPrivateRoom) {
                        
                        let person = _.find(self.member_list, (item) => {
                           
                            return item.memberId == self.userID
                        })
                        let inRoomInfo = {
                            memberRole: person.memberType,
                            memberType: self.allmembertype[person.memberType],
                            memberName: person.memberName,
                            memberStatus: 'ONLINE',
                            memberTime: Date.parse(new Date())
                        }
                        self.$refs.inside.inOutRoomList(inRoomInfo)
                    }
                })
                // }
            RTC.on("onRemoteStreamUpdate", function(info) {
                    
                    // console.log(info);
                    // self.$set(self.requestingPushers, info.userId, { 'video': true, 'audio': true })
                    self.$set(self.pusherVideosDisplay, info.userId, false)
                    this.onRemoteStreamUpdateInfo = info
                    self.memberVudeoType(info, false)
                    let person = _.find(self.member_list, (item) => {
                        return item.memberId == info.userId
                    })
                    if (!self.isPrivateRoom && self.hasNoPersonq > 1 && info.type === 'audio') { //! info信息拿到两次，导致系统提示进入人员重复。
                        self.$message({ message: self.allmembertype[person.memberType] + (person.memberType == 'MEDIATOR'?'':person.memberName) + '进入视频会议', type: 'warning', customClass: 'pop-message' });
                    }
                    if (!self.isPrivateRoom && self.hasNoPersonq > 1) {
                        let inRoomInfo = {
                            memberRole: person.memberType,
                            memberType: self.allmembertype[person.memberType],
                            memberName: person.memberName,
                            memberStatus: 'ONLINE',
                            memberTime: Date.parse(new Date())
                        }
                        if (info.type === 'audio') { //! info信息拿到两次，导致系统提示进入人员重复。
                            if(self.selfRole !== 'ROOM_WATCHER') {   //todo 无画面观摩人不调用侧边栏控制台
                                self.$refs.inside.inOutRoomList(inRoomInfo);
                            }
                        }
                    }
                    if(self.comdata.roleType === 'ROOM_WATCHER') {
                        self.watchTCPlayer() //无画面观摩人新方案
                    }
                    
                    if(info.type === 'video') {

                        self.recordOnce++
                    }

                    self.alertAllpeoRecord()
            });
            RTC.on("onRemoteStreamRemove", function(info) {
                // console.log(info);
                // self.lastLoginInfo.outRoomTime = Date.parse(new Date());
                self.$set(self.pusherVideosDisplay, info.userId, true)
                let person = _.find(self.member_list, (item) => { //离开房间的人
                    return item.memberId == info.userId
                })
                let privatePerson = _.find(self.member_list, (item) => { //在私聊房间的人
                    return item.memberStatus == 'PRIVATE'
                })
                if (getStore(info.userId)) {
                    removeStore(info.userId);
                }
                if (self.isOnPriva) {
                    if (privatePerson.memberId != info.userId && info.userId != self.mediatorInfo.id && info.userId != privateUserId) {
                        self.$message({ message: self.allmembertype[person.memberType] + (person.memberType == 'MEDIATOR'?'':person.memberName) + '离开视频会议', type: 'warning', customClass: 'pop-message' });
                    }
                } else {
                    // 
                    if (person.userName === 'ARBITRATOR' || person.userName === 'EVIDENCE_RECORD') {
                        self.$message({ message:person.memberName + '离开视频会议', type: 'warning', customClass: 'pop-message' });
                    } else {
                        self.$message({ message: self.allmembertype[person.memberType] + (person.memberType == 'MEDIATOR'?'':person.memberName) + '离开视频会议', type: 'warning', customClass: 'pop-message' });
                    }                   
                }
                if (!self.isOnPriva) {
                    // if (privatePerson.memberId != info.userId && info.userId != self.mediatorInfo.id && info.userId != privateUserId) {
                    let outRoomInfo = {
                        memberRole: person.memberType,
                        memberType: self.allmembertype[person.memberType],
                        memberName: person.memberName,
                        memberStatus: 'OFFLINE',
                        memberTime: Date.parse(new Date())
                    }
                    let loginInfo = JSON.parse(getStore("loginInfo"));
                    if(loginInfo.memberType !== 'ROOM_WATCHER') {   //todo 无画面观摩人不调用侧边栏控制台
                        self.$refs.inside.inOutRoomList(outRoomInfo)
                    }
                        // }
                }
            });

            RTC.on("onKickOut", function() {
                self.goHomeRouter();
            });

            RTC.on("onWebSocketClose", function() {
                self.goHomeRouter();
            });

            RTC.on("onRelayTimeout", function() {
                self.goHomeRouter();
            });

            RTC.on('onErrorNotify', function(info) {
                
            })

        },
        leavePriveRoom() {
            var self = this;
            self.time_funs(false);
            self.ptivateMytime = '00:00:00';
            self.ws.send(JSON.stringify({ event: 'FORCE_QUIT_PRIVATE_VIDEO' }))
        },
        sendRoom() {
            // 获取当前房间所有的信息（举手信息以及所有人音视频开关信息）
            var data = {};
            var msgdata = {};
            msgdata.event = "ROOM";
            msgdata.data = data;
            this.ws.send(JSON.stringify(msgdata))
        },
        heartbeat() { // 心跳事件
            var self = this;
            self.ws.send(JSON.stringify({ event: 'HEARTBEAT' }))
        },
        computeFirstHand(newData) {
            let minValue = null,
                minKey = null
            
            Object.keys(newData).forEach((item) => {
                if (newData[item] < minValue || !minValue) {
                    minValue = newData[item]
                    minKey = item
                }
            })
            this.firstHand = {
                [minKey]: minValue
            }
        },
        initRoomInfo(data) { // 初始化数据
            let self = this;
            let isRecord = false
            this.speechMode = data.speechModeEnums
            this.handMap = data.handMap
            this.computeFirstHand(this.handMap)
            this.lastLoginMember = data.lastLoginMember
            this.isRaiseHand = this.handMap[this.userID]
            this.videotape = data.startRecord
            this.hasNoPersonq++;
            this.onlinePerson = 0   //人员更新就会触发需要初始化
            for (let i = 0; i < data.members.length; i++) {
                if (data.members[i].memberId == self.userID) {
                    self.selfRole = data.members[i].memberType
                        // self.ismediator = data.members[i].memberType == 'MEDIATOR'?true:false
                        // self.$set(self.comdata, 'mediatorself', self.ismediator)
                    self.$set(self.comdata, 'roleType', self.selfRole)
                    self.isvideoopen = data.members[i].memberVideoStatus
                    self.isaudioopen = data.members[i].memberVoiceStatus
                    if (data.members[i].memberType != 'MEDIATOR') {
                        self.currentPlayerMedia = data.members[i].memberVideoStatus
                        if (!self.isvideoopen && data.members[i].videoOperator == 'MEDIATOR') { self.videoStatus = false }
                        if (!self.isaudioopen && data.members[i].voiceOperator == 'MEDIATOR') { self.audioStatus = false }
                    }
                }
                if (data.members[i].memberType == 'MEDIATOR') {
                    self.mediatorInfo.id = data.members[i].memberId;
                    self.mediatorInfo.name = data.members[i].memberName;
                    self.mediatorInfo.role = 'MEDIATOR';
                    self.mediatorInfo.rolename = '仲裁员';
                    if (data.members[i].memberStatus == 'PRIVATE') {
                        self.isOnPriva = true
                    }
                }
                if(data.members[i].memberType !== 'MEDIATOR' && data.members[i].memberStatus === 'ONLINE') {
                    this.onlinePerson++
                }

            }
            // if (self.ismediator) {
            //     self.insideshow = true
            // };
            for (let i = 0; i < data.members.length; i++) {
                if (data.members[i].memberStatus == 'ONLINE'&&data.members[i].memberType !== 'MEDIATOR') {
                    isRecord = true;
                    break;
                } else {
                    isRecord = false
                }
            }
            

            self.member_list = data.members;
            
            if (Object.keys(self.requestingPushers).length == 0) {
                for (let i = 0; i < data.members.length; i++) {
                    self.$set(self.requestingPushers, data.members[i].memberId, { 'video': data.members[i].memberVideoStatus, 'audio': data.members[i].memberVoiceStatus, 'shield': data.members[i].shield })
                    self.$set(self.pusherVideosDisplay, data.members[i].memberId, data.members[i].shield)
                    self.$set(self.messageActive, data.members[i].memberId, { isnew: false, isread: false })
                }
            } else if(data.members.length > Object.keys(self.requestingPushers).length){
                let newArr = data.members.filter(item=>!(Object.keys(self.requestingPushers)).some(ele=>(ele-0)===(item.memberId-0)));
                for (let i = 0; i < newArr.length; i++) {
                    self.$set(self.requestingPushers, newArr[i].memberId, { 'video': newArr[i].memberVideoStatus, 'audio': newArr[i].memberVoiceStatus, 'shield': newArr[i].shield })
                    self.$set(self.pusherVideosDisplay, newArr[i].memberId, newArr[i].shield)
                    self.$set(self.messageActive, newArr[i].memberId, { isnew: false, isread: false })
                }
            }

            if (data.voiceDiscernSwitch && !self.iswatcher) { // 用户进入视频 如果语音识别开启则开启当事人语音识别
                self.$refs.inside.speechDiscernInit(self.isaudioopen);
            }
            // if (self.updatestatus&&self.ismediator) {
            //     self.updatestatus = false
            //     updateStart({"caseId": self.caseID,"meetingId": self.meetingID})
            // }
            if (self.ismediator) {
                if (self.faceInit) {
                    self.countenanceSwitch()
                    self.faceInit = false
                    self.member_list.forEach((item) => {
                        self.$set(self.emotional, item.memberId, self.listEmotional)
                    })
                }
                // if (!self.videotape) {
                //     if(isRecord){
                //         console.log("开始录制")
                //         let data = {
                //             content: "开始录制"
                //         };
                //         let msgdata = {};
                //         msgdata.event = "START_RECORD";
                //         msgdata.data = data;
                //         self.ws.send(JSON.stringify(msgdata))
                //     }
                // }
            }
            if(self.hasNoPersonq <= 1) {
                let temp = [];
                self.member_list.forEach((item) => {
                    if (item.memberType == "APPLICANT" ||
                    item.memberType == "LITIGANT_THIRD" ||item.memberType == "LITIGANT_WITNESS" || item.memberType == "APPLICANT_AGENT" || item.memberType == "RESPONDENT" || item.memberType == "RESPONDENT_AGENT" || item.memberType == "PETITION_AGENT" || item.memberType == "MEDIATOR_HELP_TEMPORARY" || item.memberType == "MEDIATOR_HELP" || item.memberType == 'LITIGANT' || item.memberType == 'INVITATION_WATCHER' || item.memberType == 'INVITATION_WATCHER2') {
                        if (item.memberStatus == 'ONLINE') {
                            let videoElement = document.getElementById("v_" + item.memberId);
                            if (videoElement) {
                                videoElement.srcObject = null;
                                videoElement.muted = false
                            }
                            let member = {
                                id: item.memberId,
                                name: item.memberName,
                                request: false,
                                role: item.memberType,
                                rolename: self.allmembertype[item.memberType],
                                ts: Date.now(),
                                stream: '',
                                openId: item.memberId,
                                streamId: item.streamId
                            };
                            temp.push(member);
                        }
                    } else if (item.memberType == "MEDIATOR") {
                        // if (item.memberId == info.userId) {
                            self.$set(self.mainView, 'id', item.memberId)
                            self.$set(self.mainView, 'name', item.memberName)
                            self.$set(self.mainView, 'stream', '')
                            self.$set(self.mainView, 'role', 'MEDIATOR')
                            self.$set(self.mainView, 'rolename', '仲裁员')
                            self.$set(self.mainView, 'request', false)
                            self.$set(self.mainView, 'ts', Date.now())
                            self.$set(self.mainView, 'openId', item.memberId)
                            self.$set(self.mainView, 'streamId', item.streamId)
                        // }
                    }
                })
                self.members = temp;
                console.log(self.members)
            }
        },
        raiseHand() {
            // 当事人的举手事件
            if (this.isRaiseHand) {
                this.$message({ message: '您已提交过申请了，等待调解员解除静音', type: 'warning', customClass: 'pop-message' });
            } else {
                var data = {};
                var msgdata = {};
                msgdata.event = "HAND";
                msgdata.data = data;
                this.ws.send(JSON.stringify(msgdata))
            }
        },
        receiveHand(data) {
            if (data[this.userID]) {
                this.isRaiseHand = true
                this.$message({ message: '已提交发言申请，等待仲裁员解除禁音', type: 'warning', customClass: 'pop-message' });
            }
            if (this.userID == this.mediatorInfo.id) {
                let handKey = Object.keys(data)[0]
                const person = _.find(this.member_list, (item) => {
                    return item.memberId == handKey
                })
                this.handMap[handKey] = data[handKey]
                this.computeFirstHand(this.handMap)
                this.$message({ message: this.allmembertype[person.memberType] + person.memberName + '想要开启语音', type: 'warning', customClass: 'pop-message' });
            }
        },
        actionEnterRoom(opts) { // 创建视频房间
            this.RTC.createRoom({
                roomid: opts.roomId * 1,
                privateMapKey: opts.privateMapKey,
                role: "user"
            })
        },
        memberVudeoType(info, isexit) { // 拉取远程视频流
            if(!info) {
                return
            }
            let self = this,
                memberType, memberId, memberName, streamId
            if (self.hasNoPersonq <= 1) {
                self.member_list.forEach((item) => {
                    if (item.memberType == "LITIGANT_THIRD" ||item.memberType == "LITIGANT_WITNESS" || item.memberType == "APPLICANT" || item.memberType == "APPLICANT_AGENT" || item.memberType == "RESPONDENT" || item.memberType == "RESPONDENT_AGENT" || item.memberType == "PETITION_AGENT" || item.memberType == "MEDIATOR_HELP_TEMPORARY" || item.memberType == "MEDIATOR_HELP" || item.memberType == 'LITIGANT' || item.memberType == 'INVITATION_WATCHER' || item.memberType == 'INVITATION_WATCHER2') {
                        if (item.memberId == info.userId) {
                            let videoElement = document.getElementById("v_" + info.userId);
                            if (videoElement) {
                                videoElement.srcObject = null;
                                videoElement.muted = false
                            }
                            if (info.stream) {
                                let temp = [],
                                    dtemp = [],
                                    thename, memberid
                                for (let i = 0; i < self.members.length; i++) {
                                    if (self.members[i].openId != info.openId) {
                                        temp.push(self.members[i])
                                    }
                                }
                                let member = {
                                    id: item.memberId,
                                    name: item.memberName,
                                    request: isexit,
                                    role: item.memberType,
                                    rolename: self.allmembertype[item.memberType],
                                    ts: Date.now(),
                                    stream: info.stream,
                                    openId: info.openId,
                                    streamId: item.streamId
                                };
                                temp.push(member);
                                self.members = temp;
                                console.log(self.members)
                            }
                        }
                    } else if (item.memberType == "MEDIATOR") {
                        if (item.memberId == info.userId) {
                            self.$set(self.mainView, 'id', item.memberId)
                            self.$set(self.mainView, 'name', item.memberName)
                            self.$set(self.mainView, 'stream', info.stream)
                            self.$set(self.mainView, 'role', 'MEDIATOR')
                            self.$set(self.mainView, 'rolename', '仲裁员')
                            self.$set(self.mainView, 'request', false)
                            self.$set(self.mainView, 'ts', Date.now())
                            self.$set(self.mainView, 'openId', item.memberId)
                            self.$set(self.mainView, 'streamId', item.streamId)
                        }
                    }
                })
            } else {
                if (info.userId == self.mainView.id) {
                    self.$set(self.mainView, 'stream', info.stream)
                } else if (self.mainView.id == '' && info.userId == self.mediatorInfo.id) {
                    self.member_list.forEach((item) => {
                        if (item.memberId == info.userId) {
                            self.$set(self.mainView, 'id', item.memberId)
                            self.$set(self.mainView, 'name', item.memberName)
                            self.$set(self.mainView, 'stream', info.stream)
                            self.$set(self.mainView, 'role', 'MEDIATOR')
                            self.$set(self.mainView, 'rolename', '仲裁员')
                            self.$set(self.mainView, 'request', false)
                            self.$set(self.mainView, 'ts', Date.now())
                            self.$set(self.mainView, 'openId', item.memberId)
                            self.$set(self.mainView, 'streamId', item.streamId)
                        }
                    })
                } else {
                    self.member_list.forEach((item) => {
                        if ((item.memberId == info.userId) && info.stream) {
                            let temp = [],
                                dtemp = [],
                                thename, memberid
                            for (let i = 0; i < self.members.length; i++) {
                                if (self.members[i].openId != info.openId) {
                                    temp.push(self.members[i])
                                }
                            }
                            let member = {
                                id: item.memberId,
                                name: item.memberName,
                                request: isexit,
                                role: item.memberType,
                                rolename: self.allmembertype[item.memberType],
                                ts: Date.now(),
                                stream: info.stream,
                                openId: info.openId,
                                streamId: item.streamId
                            };
                            if (info.userId == self.mediatorInfo.id) {
                                if (self.userID == temp[0].id) {
                                    temp.splice(1, 0, member);
                                } else {
                                    temp.unshift(member);
                                }
                            } else {
                                temp.push(member);
                            }
                            self.members = temp;
                            console.log(self.members)
                        }
                    })
                }
            }
        },
        onSpeechModeChange(data) {
            let mode = data.mode
            let muteArray = {},
                broadcastArray = {};
            for (let key in this.requestingPushers) {
                if (key == this.mediatorInfo.id) {
                    // 自由模式下，设置了主视频（不是调解员），切成指定模式，这时候，调解员的声音跟之前设置的一样，其他人静音
                    muteArray[key] = {
                        audio: this.requestingPushers[key].audio,
                        video: this.requestingPushers[key].video
                    };
                    broadcastArray[key] = {
                        audio: this.requestingPushers[key].audio,
                        video: this.requestingPushers[key].video
                    }
                } else {
                    muteArray[key] = {
                        audio: false,
                        video: this.requestingPushers[key].video
                    };
                    broadcastArray[key] = {
                        audio: true,
                        video: this.requestingPushers[key].video
                    }
                }
            }
            if (mode === 'FREE') {
                this.requestingPushers = broadcastArray
                this.speechMode = 'FREE'
                this.handMap = {}
                this.computeFirstHand(this.handMap)
                this.isRaiseHand = false
                this.firstHand = {}
                this.audioStatus = true
                this.currentSpeechUserId = null
                if (this.userID == this.mediatorInfo.id) {
                    this.$message({ message: '已切换为自由发言模式，所有参会人员将开启语音', type: 'warning', customClass: 'pop-message' });
                    // 切换后，默认将调解员设为主视频（用户手动设置的主屏幕优先级最高）
                    if (!this.selectedMainViewId) {
                        let member = {...this.mainView };
                        if (member.id != this.mediatorInfo.id) {
                            this.members.forEach((item, index, array) => {
                                if (item.id == this.mediatorInfo.id) {
                                    array.splice(index, 1, member)
                                    this.$set(this.mainView, 'id', item.id)
                                    this.$set(this.mainView, 'name', item.name)
                                    this.$set(this.mainView, 'stream', item.stream)
                                    this.$set(this.mainView, 'role', item.role)
                                    this.$set(this.mainView, 'rolename', this.allmembertype[item.role])
                                    this.$set(this.mainView, 'request', false)
                                    this.$set(this.mainView, 'ts', item.ts)
                                    this.$set(this.mainView, 'openId', item.openId)
                                }
                            })
                        }
                    }
                } else {
                    this.isaudioopen = true
                    this.RTC && this.RTC.openAudio();
                    this.$refs.inside.speechOpenWithAudio();
                    this.$message({ message: '已切换为自由发言模式，您已被解除禁音，可以自由发言', type: 'warning', customClass: 'pop-message' });
                    // 未设置主视频，当前主视频为发言者，切为自由发言模式时，主视频为调解员
                    if (!this.selectedMainViewId) {
                        let member = {...this.mainView };
                        if (member.id != this.mediatorInfo.id) {
                            if (member.id == this.userID) {
                                this.members.forEach((item, index, array) => {
                                    if (item.id == this.mediatorInfo.id) {
                                        array.splice(index, 1)
                                        array.splice(0, 0, member)
                                        this.setMainView(item)
                                    }
                                })
                            } else {
                                this.setMainView(this.members[1])
                                this.members.splice(1, 1, member)
                            }
                        }
                    }
                }
            } else if (mode === 'SPECIFY') {
                this.requestingPushers = muteArray
                this.speechMode = 'SPECIFY'
                this.handMap = {}
                this.computeFirstHand(this.handMap)
                this.isRaiseHand = false
                this.firstHand = {}
                this.audioStatus = false
                if (this.userID == this.mediatorInfo.id) {
                    this.$message({ message: '已切换为指定发言模式，您可以通过解除发言人语音指定其发言，每次只能指定一人发言', type: 'warning', customClass: 'pop-message' });
                } else {
                    this.isaudioopen = false
                    this.RTC && this.RTC.closeAudio();
                    this.$refs.inside.speechColsedWithAudio();
                    this.$message({ message: '已切换为指定发言模式，您已被禁音，将由调解员指定人员发言', type: 'warning', customClass: 'pop-message' });
                }
            }
        },
        setMainScreen(id, isParty = false) {
            // 判断仲裁庭或者仲裁员是否进入会议
            if (this.mainView.stream == '') {
                if (this.virtualParticipants.length) {
                    this.$message({ message: '仲裁庭未进入会议，禁止设置主视频', type: 'warning', customClass: 'pop-message' });
                } else {
                    this.$message({ message: '仲裁员未进入会议，禁止设置主视频', type: 'warning', customClass: 'pop-message' });
                }
                return
            }
            // 设为主屏幕， isParty = true即为 当事人设为主屏幕
            let member = {...this.mainView }; //当前主屏幕的人员
            this.members.forEach((item, index, array) => {
                if (item.id == id) {
                    if (isParty) {
                        // 当前用户是当事人的角色， 设为主屏幕
                        if (member.id == this.userID) {
                            //当前用户是当事人的角色，并且在主屏幕上
                            array.splice(index, 1)
                            array.unshift(member)
                        } else if (member.id == this.mediatorInfo.id) {

                            //当前用户是当事人的角色，并且调解员在主屏幕上
                            if (id == this.userID) {
                                // 对当前用户进行操作
                                array.splice(0, 1, member)
                            } else {
                                array.splice(index, 1)
                                array.splice(1, 0, member)
                            }
                        } else {
                            if (id == this.userID) {
                                array.splice(0, 1)
                                array.splice(1, 0, member)
                            } else if (id == this.mediatorInfo.id) {
                                array.splice(1, 1, member)
                            } else {
                                array.splice(index, 1)
                                array.splice(2, 0, member)
                            }
                        }
                    } else {
                        // 当前用户是调解员的角色， 设为主屏幕
                        if (member.id == this.mediatorInfo.id) {
                            // 调解员在主屏幕上
                            array.splice(index, 1)
                            array.unshift(member)
                        } else {
                            if (id == this.mediatorInfo.id) {
                                // 调解员不在主屏幕上， 调解员对调解员设置主视频
                                array.splice(index, 1, member)
                            } else {
                                // 调解员不在主屏幕上， 调解员对当事人设置主视频
                                array.splice(index, 1)
                                array.splice(1, 0, member)
                            }
                        }
                    }
                    this.$set(this.mainView, 'id', item.id)
                    this.$set(this.mainView, 'name', item.name)
                    this.$set(this.mainView, 'stream', item.stream)
                    this.$set(this.mainView, 'streamId', item.streamId)
                    this.$set(this.mainView, 'role', item.role)
                    this.$set(this.mainView, 'rolename', this.allmembertype[item.role])
                    this.$set(this.mainView, 'request', false)
                    this.$set(this.mainView, 'ts', item.ts)
                    this.$set(this.mainView, 'openId', item.openId)
                    this.selectedMainViewId = item.id
                }
            })
            
        },
        cancelMainScreen() {
            // 取消主视频
            let member = {...this.mainView };
            let mediator
            this.selectedMainViewId = null
            if (member.id == this.mediatorInfo.id) {
                mediator = member
                if (this.currentSpeechUserId) {
                    let personIndex = _.findIndex(this.members, (item) => {
                        return item.id == this.currentSpeechUserId
                    })
                    this.setMainView(this.members[personIndex])
                    this.members.splice(personIndex, 1)
                    this.members.unshift(member)
                }
            } else {
                mediator = this.members[0]
                if (this.currentSpeechUserId) {
                    let personIndex
                    if (this.currentSpeechUserId != member.id) {
                        personIndex = _.findIndex(this.members, (item) => {
                            return item.id == this.currentSpeechUserId
                        })
                        this.setMainView(this.members[personIndex])
                        this.members.splice(personIndex, 1)
                        this.members.splice(1, 0, member)
                    }
                } else {
                    this.setMainView(mediator)
                    this.members.splice(0, 1, member)
                }
            }
        },
        partyCancelMainScreen(id) {
            let newMainView = {}
            let member = {...this.mainView };
            this.selectedMainViewId = null
            if (id == this.mediatorInfo.id) {
                if (this.currentSpeechUserId) {
                    if (this.currentSpeechUserId != id) {
                        let personIndex = _.findIndex(this.members, (item) => {
                            return item.id == this.currentSpeechUserId
                        })
                        newMainView = this.members[personIndex]
                        if (personIndex == 0) {
                            this.members.splice(0, 1, member)
                        } else {
                            this.members.splice(personIndex, 1)
                            this.members.splice(1, 0, member)
                        }
                        this.setMainView(newMainView)
                    }
                } else {
                    newMainView = this.members[0]
                    this.members.splice(0, 1, member)
                    this.setMainView(newMainView)
                }
            } else if (id == this.userID) {
                if (this.currentSpeechUserId) {
                    if (this.currentSpeechUserId != id) {
                        let personIndex = _.findIndex(this.members, (item) => {
                            return item.id == this.currentSpeechUserId
                        })
                        newMainView = this.members[personIndex]
                        if (personIndex == 0) {
                            this.members.splice(0, 1, member)
                        } else {
                            this.members.splice(personIndex, 1)
                            this.members.splice(0, 0, member)
                        }
                        this.setMainView(newMainView)
                    }
                } else {
                    if (this.members[0].id == this.mediatorInfo.id) {
                        newMainView = this.members[0]
                        this.members.splice(0, 1, member)
                        this.setMainView(newMainView)
                    } else {
                        newMainView = {
                            id: '',
                            name: '',
                            stream: '',
                            role: '',
                            rolename: '',
                            ts: '',
                            openId: '',
                            request: ''
                        }
                        this.members.unshift(member)
                        this.setMainView(newMainView)
                    }
                }
            } else {
                if (this.currentSpeechUserId) {
                    if (this.currentSpeechUserId != id) {
                        let personIndex = _.findIndex(this.members, (item) => {
                            return item.id == this.currentSpeechUserId
                        })
                        newMainView = this.members[personIndex]
                        if (personIndex == 0) {
                            // 指定用户是当前用户
                            this.members.splice(0, 1)
                            this.members.splice(1, 0, member)
                        } else if (personIndex == 1) {
                            this.members.splice(1, 1)
                            this.members.splice(1, 0, member)
                        } else {
                            this.members.splice(personIndex, 1)
                            this.members.splice(2, 0, member)
                        }
                        this.setMainView(newMainView)
                    }
                } else {
                    newMainView = this.members[1]
                    this.members.splice(1, 1, member)
                    this.setMainView(newMainView)
                }
            }
        },
        changeSpeechMode() {
            const sendSpeechEvent = (mode) => {
                var data = {
                    mode
                };
                var msgdata = {};
                msgdata.event = "SPEECH_MODE_CHANGE";
                msgdata.data = data;
                this.ws.send(JSON.stringify(msgdata))
            }
            if (this.speechMode === 'SPECIFY') {
                sendSpeechEvent('FREE')
            } else {
                sendSpeechEvent('SPECIFY')
            }
        },
        throwScreen(id, name, item) {
            this.ScreenId = id;
            this.ScreenName = name;
            this.streamId = item.streamId;
            console.log('toup',
                item.streamId)
            
            if (getStore(id)) {
                this.$message('该视频窗口正在投屏中');
            } else {
                if (getStore('checked')) {
                    this.DialogVisible = false;
                    this.sureThrowScreen();
                } else {
                    this.DialogVisible = true;
                }
                setStore(id)
            }

        },
        sureThrowScreen() {
            this.ws.send(JSON.stringify({ event: 'GET_TEMP_MEMBER' }))

        },
        memberListScroll(bl) {
            if (bl) {
                this.scrollLength = Boolean(this.$refs.meetingMemberList.scrollLeft % 250) > 0 ? this.$refs.meetingMemberList.scrollLeft : (this.scrollLength + 250)
            } else {
                this.scrollLength = Boolean(this.$refs.meetingMemberList.scrollLeft) == 0 ? 0 : this.scrollLength - 250
            }
            this.$refs.meetingMemberList.scrollLeft = this.scrollLength
        },
        closeVideo() { // 开关自己的视频
            if (this.videoStatus) {
                if (this.ownvideoopen) {
                    
                    this.RTC.closeVideo()
                    if (!this.ismediator) { this.$set(this.requestingPushers[this.userID], 'video', false) }
                } else {
                    
                    this.RTC.openVideo();
                    if (!this.ismediator) { this.$set(this.requestingPushers[this.userID], 'video', true) }
                }
                this.ownvideoopen = !this.ownvideoopen
            }
        },
        controlVideo(id, type) { // 调解员控制当事人视频
            if (this.isvideoopen) {
                if (this.userID == id) {
                    this.RTC && this.RTC.closeVideo();
                }
                if (type) {
                    this.videoStatus = false;
                }
                this.$set(this.requestingPushers[id], 'video', false)
            } else {
                if (this.userID == id) {
                    this.RTC && this.RTC.openVideo();
                }
                if (type) {
                    this.videoStatus = true;
                }
                this.$set(this.requestingPushers[id], 'video', true)
            }
            this.isvideoopen = !this.isvideoopen
        },
        controlOtherVideo(id, type) { // 非当事人自己
            let otherVideoStatus = !Boolean(this.requestingPushers[id] && this.requestingPushers[id]['video'])
            this.$set(this.requestingPushers[id], 'video', otherVideoStatus)
        },
        controlAudio(id, type) { //  当被操作的人(当事人/调解员)是当前用户的时候, 收到调解员/当事人切换音频的消息
            // type = 1 为调解员控制，  type = 0 为当事人控制
            if (this.isaudioopen) {
                this.RTC && this.RTC.closeAudio();
                this.$refs.inside.speechColsedWithAudio(false);
                if (type) {
                    this.audioStatus = false;
                }
            } else {
                this.RTC && this.RTC.openAudio();
                this.$refs.inside.speechOpenWithAudio(true);
                if (type) {
                    this.audioStatus = true;
                }
            }

            if (!this.requestingPushers[id].audio) {
                delete this.handMap[id]
                this.computeFirstHand(this.handMap)
            }
            if (this.speechMode === 'SPECIFY') {
                this.muteOthers(id)
            } else {
                let value = this.isaudioopen ? false : true
                this.isRaiseHand = false
                this.$set(this.requestingPushers[id], 'audio', value)
            }

            this.isaudioopen = !this.isaudioopen
        },
        muteOthers(id) {
            //指定发言的时候，调解员每次只能指定一人发言，后指定发言者解除静音后，前指定发言者将自动静音，切换发言人
            let muteArray = {}
            if (id == this.mediatorInfo.id) {
                //当如果是调解员自己语音调整，不应该影响其他人.
                let otherVideoStatus = !Boolean(this.requestingPushers[id] && this.requestingPushers[id]['audio'])
                this.$set(this.requestingPushers[id], 'audio', otherVideoStatus)
            } else {
                // 如果是调解员对某一当事人修改音频，其它当事人要变成静音，调解员本身的音频不变
                delete this.handMap[id]
                this.computeFirstHand(this.handMap)
                if (id == this.userID) {
                    this.isRaiseHand = false
                }
                for (let key in this.requestingPushers) {
                    if (key == this.mediatorInfo.id) {
                        muteArray[key] = {
                            audio: this.requestingPushers[key].audio,
                            video: this.requestingPushers[key].video
                        };
                    } else if (key == id) {
                        muteArray[key] = {
                            audio: !this.requestingPushers[key].audio,
                            video: this.requestingPushers[key].video
                        };
                    } else {
                        muteArray[key] = {
                            audio: false,
                            video: this.requestingPushers[key].video
                        };
                    }
                }
                this.requestingPushers = muteArray
            }
        },
        controlOtherAudio(id, type) { // 调解员控制当事人音频， 当被操作音频的人不是当前用户的时候
            if (this.speechMode === 'SPECIFY') {
                this.muteOthers(id)
                if (id != this.mediatorInfo.id && this.userID != this.mediatorInfo.id) {
                    this.isaudioopen = false
                    this.RTC && this.RTC.closeAudio();
                    this.$refs.inside.speechColsedWithAudio();
                    if (type) {
                        this.audioStatus = false;
                    }
                }
            } else {
                let otherAudioStatus = !Boolean(this.requestingPushers[id] && this.requestingPushers[id]['audio']);
                if (!this.requestingPushers[id].audio) {
                    delete this.handMap[id]
                    this.computeFirstHand(this.handMap)
                }
                this.$set(this.requestingPushers[id], 'audio', otherAudioStatus);
            }
        },
        closeAudioMedtiator(id, type) { // 调解员开关当事人麦克
            if (type || this.audioStatus) {
                let self = this,
                    data, msgdata = {};
                if (type) {
                    data = { mediaType: "VOICE", memberId: id, operator: "MEDIATOR" }
                } else {
                    data = { mediaType: "VOICE", memberId: id, operator: "OWNER" }
                }
                msgdata.event = "SWITCH_MEDIA"
                msgdata.data = data
                if (!self.socketStatus) {
                    self.ws.onopen = function(evt) {
                        self.socketStatus = true
                    }
                }
                this.ws.send(JSON.stringify(msgdata))
            } else if (!type && !this.audioStatus) {
                this.$message({ message: '您已被主持人静音了', type: 'warning', customClass: 'pop-message' });
            }
        },
        closeVideoMedtiator(id, type) { // 调解员开关当事人摄像
            if (type || this.videoStatus) {
                let self = this,
                    data, msgdata = {},
                    videoSatus = !Boolean(this.requestingPushers[id] && this.requestingPushers[id]['video'])
                if (type) {
                    data = { mediaType: "VIDEO", memberId: id, operator: "MEDIATOR" }
                } else {
                    data = { mediaType: "VIDEO", memberId: id, operator: "OWNER" }
                }
                msgdata.event = "SWITCH_MEDIA"
                msgdata.data = data
                if (!self.socketStatus) {
                    self.ws.onopen = function(evt) {
                        self.socketStatus = true
                    }
                }
                this.ws.send(JSON.stringify(msgdata))
                    // self.$set(self.requestingPushers[id],'video',videoSatus)
            } else if (!type && !this.videoStatus) {
                this.$message({ message: '主持人禁用了您的视频，可联系主持人开启视频', type: 'warning', customClass: 'pop-message' });
            }
        },
        hiddenUserScreen(memberId, shield) {
            //屏蔽当事人功能
            if(shield) {
                this.ws.send(JSON.stringify({event:'SHIELD_MEMBER', data: {memberId: memberId, isShield: false}}))
                this.$set(this.requestingPushers[memberId], "shield", false);
            } else {
                this.ws.send(JSON.stringify({event:'SHIELD_MEMBER', data: {memberId: memberId, isShield: true}}))
                this.$set(this.requestingPushers[memberId], "shield", true);
            }
        },
        setMainView(item) {
            this.$set(this.mainView, 'id', item.id)
            this.$set(this.mainView, 'name', item.name)
            this.$set(this.mainView, 'stream', item.stream)
            this.$set(this.mainView, 'role', item.role)
            this.$set(this.mainView, 'rolename', this.allmembertype[item.role])
            this.$set(this.mainView, 'request', false)
            this.$set(this.mainView, 'ts', item.ts)
            this.$set(this.mainView, 'openId', item.openId)
        },
        partyReceiveMedia(opt) { // 当事人/调解员 接收到当事人/调解员的音视频开关信号
            if (opt.memberId == this.userID) {
                if (opt.mediaType == "VOICE") {
                    if (opt.operator == "MEDIATOR") {
                        if (this.speechMode === 'SPECIFY') {
                            this.currentSpeechUserId = opt.memberId
                        }
                        this.controlAudio(opt.memberId, 1)
                    } else if (opt.operator == "OWNER") {
                        this.controlAudio(opt.memberId, 0)
                    }
                } else if (opt.mediaType == "VIDEO") {
                    if (opt.operator == "MEDIATOR") {
                        this.controlVideo(opt.memberId, 1)
                    } else if (opt.operator == "OWNER") {
                        this.controlVideo(opt.memberId, 0)
                    }
                }
            } else {
                if (opt.mediaType == "VOICE") {
                    if (this.speechMode === 'SPECIFY') {
                        this.currentSpeechUserId = opt.memberId
                    }
                    this.controlOtherAudio(opt.memberId, 1)
                } else if (opt.mediaType == "VIDEO") {
                    this.controlOtherVideo(opt.memberId, 1)
                }
            }
            if (this.speechMode === 'SPECIFY' && !this.selectedMainViewId && this.requestingPushers[opt.memberId].audio && opt.memberId != this.mainView.id) {
                //指定发言模式下  没设置主视频 并且 当前操作是打开语音 并且 主视频的人不等于当前操作的人的时候
                let member = {...this.mainView }; //当前主屏幕的人员
                this.members.forEach((item, index, array) => {
                    if (item.id == opt.memberId) {
                        if (this.userID == this.mediatorInfo.id && opt.memberId != this.mediatorInfo.id) {
                            // 当当前用户是调解员的时候 并且不是对调解员进行开启语音操作(调解员对调解员自己进行开关语音操作，并不需要放到主屏幕上)
                            let mediatorItem = {}
                            if (member.id == this.mediatorInfo.id) {
                                mediatorItem = member

                                array.splice(index, 1)
                                array.unshift(mediatorItem)
                            } else {
                                mediatorItem = array[0]
                                array.splice(index, 1)
                                array.splice(1, 0, member)
                            }
                            this.setMainView(item)
                        }
                        if (this.userID != this.mediatorInfo.id) {
                            // 当当前用户不是调解员时候
                            if (opt.memberId == this.userID) {
                                // 当当前被指定发言人员是当前用户的时候
                                if (member.id == this.mediatorInfo.id) {
                                    array.splice(0, 1, member)
                                } else {
                                    array.splice(0, 1)
                                    array.splice(1, 0, member)
                                }
                                this.setMainView(item)
                            } else if (opt.memberId != this.mediatorInfo.id) {
                                // 当当前被指定发言人员不是当前用户、也不是调解员的时候
                                if (member.id == this.userID) {
                                    array.splice(index, 1)
                                    array.unshift(member)
                                } else if (member.id == this.mediatorInfo.id) {
                                    array.splice(index, 1)
                                    array.splice(1, 0, member)
                                } else {
                                    array.splice(index, 1)
                                    array.splice(2, 0, member)
                                }
                                this.setMainView(item)
                            }
                        }
                    }
                })
                
            }

            if (this.speechMode === 'SPECIFY' && !this.selectedMainViewId && !this.requestingPushers[opt.memberId].audio && opt.memberId == this.mainView.id && this.currentSpeechUserId && opt.operator == "MEDIATOR") {
                //指定发言模式下  没设置主视频 并且 当前操作是调解员对主视频的人关闭语音
                this.currentSpeechUserId = null
                let member = {...this.mainView }; //当前主屏幕的人员
                if (this.userID == this.mediatorInfo.id) {
                    if (this.mainView.id != this.mediatorInfo.id) {
                        //调解员界面下，并且当前主视频不是调解员，需要把主视频的人回到小视频区域
                        this.setMainView(this.members[0])
                        this.members.splice(0, 1, member)
                    }
                } else {
                    if (this.mainView.id != this.mediatorInfo.id) {
                        //当事人界面下，并且当前主视频不是调解员，需要把主视频的人回到小视频区域
                        if (opt.memberId == this.userID) {
                            this.setMainView(this.members[0])
                            this.members.splice(0, 1, member)
                        } else {
                            this.setMainView(this.members[1])
                            this.members.splice(1, 1, member)
                        }
                    }
                }
            }
        },
        openSelfChat() {
            this.currentMessageType = 'private';
            this.$refs.privatechat.openDialog()
        },
        chatSwitch(userid, username, rolename, role) {
            this.currentMessageType = 'private';
            this.$refs.privatechat.createChat(userid, username, rolename, role)
            this.$set(this.messageActive[userid], 'isnew', false)
            this.$set(this.messageActive[userid], 'isread', true)
        },
        openMediatorChat() {
            this.currentMessageType = 'private';
            this.isMediatorMessage = false;
            this.isMediatorMessageRead = true; // 下在阅读状态
            this.$refs.privatechat.createChat(this.mediatorInfo.id, this.mediatorInfo.name, this.mediatorInfo.rolename)
            // this.$refs.privatechat.createChat(this.mediatorInfo.id, this.mediatorInfo.name, '工作人员')
        },
        closeMeeting() {
            var self = this;
            var data = {
                content: "结束视频"
            };
            var msgdata = {};
            msgdata.event = "CLOSE_ROOM";
            msgdata.data = data;
            if (!self.socketStatus) {
                self.ws.onopen = function(evt) {
                    self.socketStatus = true
                }
            }
            self.$alert('<h4 class="title_red">重要提示</h4><div>是否结束当前视频会议？</div>', '温馨提示', {
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                confirmButtonText: '确定',
                confirmButtonClass: 'meeting_button_primary_small',
                cancelButtonClass: 'meeting_button_default_small',
                cancelButtonText: '取消',
                customClass: 'alert_inquire'
            }).then(() => {
                self.ws.send(JSON.stringify(msgdata));
            })
        },
        recordAudio() {
            var self = this;
            // if(self.memberStatus||self.videotape) {
            if (!self.videotape) {
                let data = {
                    content: "开始录制"
                };
                let msgdata = {};
                msgdata.event = "START_RECORD";
                msgdata.data = data;
                if (!self.socketStatus) {
                    self.ws.onopen = function(evt) {
                        self.socketStatus = true
                    }
                }
                self.$alert('<h4 class="title_red">温馨提示</h4><div>是否开始录制视频？</div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    confirmButtonClass: 'meeting_button_primary_small',
                    cancelButtonClass: 'meeting_button_default_small',
                    cancelButtonText: '取消',
                    customClass: 'alert_record'
                }).then(() => {
                    this.ws.send(JSON.stringify(msgdata))
                })
            } else {
                let data = {
                    content: "结束录制"
                };
                let msgdata = {};
                msgdata.event = "STOP_RECORD";
                msgdata.data = data;
                if (!self.socketStatus) {
                    self.ws.onopen = function(evt) {
                        self.socketStatus = true
                    }
                }
                self.$alert('<h4 class="title_red">温馨提示</h4><div>是否结束录制视频？</div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    confirmButtonClass: 'meeting_button_primary_small',
                    cancelButtonClass: 'meeting_button_default_small',
                    cancelButtonText: '取消',
                    customClass: 'alert_record'
                }).then(() => {
                    this.ws.send(JSON.stringify(msgdata))
                    self.videotape = false
                })
            }
            // }else{
            //     self.$alert('<h4 class="title_red">温馨提示</h4><div>当事人未进入会议，视频录制无法进行！</div>', '温馨提示', {
            //         dangerouslyUseHTMLString: true,
            //         confirmButtonText: '确定',
            //         confirmButtonClass: 'meeting_button_primary_small',
            //         customClass: 'alert_record'
            //     }).then(() => {})
            // }
        },
        recordResponse(data) { // 开始录制视频响应
            if (data.success) {
                this.videotape = true
            } else {
                if(data.message.indexOf("exist") != -1) {
                    this.alertAllpeoRecord()
                } else {
                    this.$alert('<h4 class="title_red">温馨提示</h4><div>' + data.message + '</div>', '温馨提示', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '确定',
                        confirmButtonClass: 'meeting_button_primary_small',
                        customClass: 'alert_record'
                    }).then(() => {
                    })
                }
            }
        },
        leaveRoom: function() {
            var self = this;
            var data = {
                content: "结束视频"
            };
            var msgdata = {};
            msgdata.event = "CLOSE_ROOM";
            msgdata.data = data;
            self.$alert('<div>结束视频后，本次视频会议将结束，不能再次进入视频</div>', '温馨提示', {
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: true,
                showCancelButton: true,
                confirmButtonText: '结束视频',
                confirmButtonClass: 'meeting_button_primary_small',
                cancelButtonClass: 'meeting_button_default_small',
                cancelButtonText: '暂时离开',
                customClass: 'alert_inquire'
            }).then(() => {
                updateEndMeeting({ "meetingId": this.meetingID },self.comdata.invite).then((res) => {});
                self.ws.send(JSON.stringify(msgdata))
            }).catch((action) => {
                if (action === 'cancel') {
                    self.wsclosed = false
                    self.$message({ message: '请于1小时内进入视频，否则系统将默认结束本次视频会议。。。', type: 'warning' });
                    self.RTC && self.RTC.quit();
                    self.ws.close()
                    setTimeout(function() {
                        // if (self.caseStatus == 'success' || self.caseStatus == 'failed') {
                        //     document.location.href = '/mediator/completed/mediator/' + self.caseID
                        // } else if (self.caseStatus == 'retract') {
                        //     document.location.href = '/mediator/index'
                        // } else {
                        history.back()
                            // }
                    }, 3000)
                }
            });
        },
        goHomeRouter: function() {
            if (!this.isOnPriva) { //判断是否进入私聊，进入私聊不退群聊
                var self = this;
                self.$alert('<h4 class="title_red">重要提示</h4><div>离开视频，视频页面将会关闭</div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    confirmButtonClass: 'meeting_button_primary_small',
                    cancelButtonClass: 'meeting_button_default_small',
                    cancelButtonText: '取消',
                    customClass: 'alert_quit'
                }).then(() => {
                    self.wsclosed = false
                    self.RTC && self.RTC.quit();
                    self.ws.close();
                    clearInterval(self.heartbeatFun)
                    if (self.comdata.istemporary) {
                        window.localStorage.removeItem('otherToken')
                    }
                    if (self.caseStatus == 'success' || self.caseStatus == 'failed' || self.caseStatus == 'retract') {
                        document.location.href = '/mediator/completed/' + self.caseID
                    } else {
                        history.back()
                    }
                })
            }
        },
        openinside(name) {
            this.insideshow = !this.insideshow
            this.$refs.inside.openCurrentTabs(name)
        },
        // self.ptivateMytime = (h >= 10 ? h : "0" + h) + ":" + (m >= 10 ? m : "0" + m) + ":" + (s >= 10 ? s : "0" + s);
        time_fun(status) { // 计时
            let sec = 0,
                self = this;
            if (status) {
                let interval = self.interval = setInterval(function() {
                    sec++;
                    let date = new Date(0, 0)
                    date.setSeconds(sec);
                    let h = date.getHours(),
                        m = date.getMinutes(),
                        s = date.getSeconds();
                    self.mytime = (h >= 10 ? h : "0" + h) + ":" + (m >= 10 ? m : "0" + m) + ":" + (s >= 10 ? s : "0" + s);

                }, 1000);
            } else {
                
                clearInterval(self.interval);
            }
        },
        time_funs(status) { // 计时
            let sec = 0,
                self = this;
            if (status) {
                let intervalReset = self.intervalReset = setInterval(function() {
                    sec++;
                    let date = new Date(0, 0)
                    date.setSeconds(sec);
                    let h = date.getHours(),
                        m = date.getMinutes(),
                        s = date.getSeconds();
                    self.ptivateMytime = (h >= 10 ? h : "0" + h) + ":" + (m >= 10 ? m : "0" + m) + ":" + (s >= 10 ? s : "0" + s);

                }, 1000);
            } else {
                
                clearInterval(self.intervalReset);
            }
        },
        getOrgid(id) {
            this.orgId = id
        },
        changStatushNotice(opt) { // 案件状态改变 退出视频时的去向
            this.caseStatus = opt.type
        },
        invitemeeting() {
            this.$refs.assistance.openAssistanceDialog(this.meetingID, this.caseID)
        },
        closeRoomVideo() {
            let self = this;
            self.RTC && self.RTC.quit();
            if (self.isOutPrivate) {
                history.back()
            } else {
                self.$alert('<h4 class="title_red">重要提示</h4><div>视频会议已结束，请确定离开</div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    confirmButtonClass: 'meeting_button_primary_small',
                    customClass: 'alert_quit'
                }).then(() => {
                    history.back()
                })
            }
        },
        pauseRoomVideo() {
            let self = this;
            self.RTC && self.RTC.quit();
            if (self.isOutPrivate) {
                history.back()
            } else {
                self.$alert('<h4 class="title_red">重要提示</h4><div>已休庭，请确定离开</div>', '温馨提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    confirmButtonClass: 'meeting_button_primary_small',
                    customClass: 'alert_quit'
                }).then(() => {
                    history.back()
                })
            }
        },
        changStatushMessage(opt) {
            if (this.ismediator) {
                Object.keys(this.messageActive).forEach((item) => {
                    this.$set(this.messageActive[item], 'isread', false)
                })
            } else {
                this.isMediatorMessage = false;
                this.isMediatorMessageRead = false; // 是否在阅读状态
            }
            if (opt) {
                this.$set(this.messageActive[opt], 'isnew', false);
                this.$set(this.messageActive[opt], 'isread', true);
            }
        },
        setSource(type) {
            this.currentMessageType = type
        },
        watchTCPlayer() {
            //实例化视频直播组件
            this.member_list.map(item=> {
                if(item.streamId) {
                    TcPlayerPeo(item)
                }
            })
            function TcPlayerPeo(item) {
                new TcPlayer(item.memberType === 'MEDIATOR' ? 'localVideo' : `v_${item.memberId}`, {
                    m3u8: `http://liveplay.e-court.gov.cn/live/${item.streamId}.m3u8`,
                    flv: `http://liveplay.e-court.gov.cn/live/${item.streamId}.flv`,
                    autoplay: true,      //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                    live: true,
                    wording: {
                        2032: '请求视频失败，请检查网络',
                        2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
                    },
                    listener: function (msg) {
                        // console.log(msg);
                        // if(msg.type == 'load') {
                        //     var _div = document.createElement('div');
                        //     _div.className = 'marker';
                        //     _div.innerText = '测试';
                        //     document.querySelector('.meeting-member-box').appendChild(_div)
                        // }
                    }
                });
            }
        },
        alertAllpeoRecord() {
            //人员全部到齐自动提示一次录制
            let self = this
            if (self.comdata.roleType == 'MEDIATOR' && !self.videotape && self.recordOnce === self.onlinePerson) {
                //调解员端所有人员到齐显示提示弹框
                let isRecordtip = false, isShieldtip = false, memberVideoStatus = false
                isRecordtip = self.ROOMData.members.some(item => item.memberStatus !== "ONLINE")
                isShieldtip = self.ROOMData.members.some(item => item.shield != false)
                memberVideoStatus = self.ROOMData.members.some(item => !item.memberVideoStatus)
                if (!isRecordtip && !isShieldtip && !memberVideoStatus) {
                    let data = {
                        content: "开始录制"
                    };
                    let msgdata = {};
                    msgdata.event = "START_RECORD";
                    msgdata.data = data;
                    if (!self.socketStatus) {
                        self.ws.onopen = function(evt) {
                            self.socketStatus = true
                        }
                    }
                    
                    self.$alert(
                        '<h4 class="title_red">温馨提示</h4><div>会议人员已经都出席了，请及时开启视频录制！</div>',
                        "温馨提示",
                        {
                            dangerouslyUseHTMLString: true,
                            showCancelButton: false,
                            confirmButtonText: "确定",
                            confirmButtonClass: "meeting_button_primary_small",
                            customClass: "alert_record"
                        }
                    ).then(() => {
                        // self.ws.send(JSON.stringify(msgdata));
                    })
                }
            }
        },
        handleBobao() {
            //仲裁庭纪律播放
            searchDictionaryInfo({
                code: 'RIGHTS_OBLIGATIONS_VEDIO_URL'
            }).then((res)=>{
                if(res.data.code === 1000) {
                    this.Bobaovideo1 = res.data.data
                    
                }
            })
            //当事人的权利与义务播放
            searchDictionaryInfo({
                code: 'MEETING_RULE_VEDIO_URL'
            }).then((res)=>{
                if(res.data.code === 1000) {
                    this.Bobaovideo2 = res.data.data
                }
            })

        },
    },
    beforeDestroy() {
        this.time_funs(false)
        this.closeInstantChat();
    }
}